import { InsertCategoryItem } from 'components'
import { useRecoilValue } from 'recoil'
import { roleAtom } from 'atoms'
import { useSetToast } from 'hooks'

export const InsertCategories = ({
  setMenu,
  showSlideout,
  selectedMenu,
  setSelectedMenu,
  setShowSlideout,
  menuConfig,
}) => {
  const userRole = useRecoilValue(roleAtom)
  const setToast = useSetToast()

  const menus = menuConfig.filter((menu) => {
    return menu.allowedFor.includes(userRole)
  })

  const handleMenuClick = (menu) => {
    if (menu.locked && menu.lockedMessage) {
      setToast({ text: menu.lockedMessage })
      return
    }
    setMenu(menu.name)
  }

  return menus?.map((menu) => (
    <InsertCategoryItem
      selected={showSlideout && selectedMenu === menu.name}
      onClick={() => handleMenuClick(menu)}
      key={menu.name}
      menu={menu.name}
      setSelectedMenu={setSelectedMenu}
      setShowSlideout={setShowSlideout}
      isLocked={menu.locked}
    >
      {menu.displayLabel}
    </InsertCategoryItem>
  ))
}

export default InsertCategories
